module.exports = {"id":"s2-q3","text":"Did the training require you to register an account and log in to view course content?","multiselect":false,"options":[{"id":"s2-q3-a1","text":"Yes","next":"s2-q4","capability":1,"access":1,"focusarea":[0,4,0,3,0]},{"id":"s2-q3-a2","text":"No","next":"s3-q1","capability":-3,"access":-3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s2-q3.json
// module id = 898
// module chunks = 41